/**
 * Created by staffanrantzow on 24/11/16.
 */

import axios from 'axios';
import IncomeStatementEntity from './incoment-statement-entity';
import PendingRequestEntity from '../entities/pending-request-entity';

class IncomeStatementService {

  hydrate (data) {
    return new IncomeStatementEntity(
      data.id,
      data.attributes.url,
      data.attributes.user_id,
      data.attributes.year
    );
  }

  hydrateCollection (data) {
    let statements = [];

    for (let d of data) {
      statements.push(this.hydrate(d));
    }

    return statements;
  }

  getIncomeStatements (userId) {
    let pendingRequest = new PendingRequestEntity();
    pendingRequest.promise = axios.get(`backend://users/${userId}/income-statements`, {
      cancelToken: new axios.CancelToken(function executor (c) {
        pendingRequest.cancel = c;
      })
    })
    .then((response) => {
      return this.hydrateCollection(response.data.data);
    });

    return pendingRequest;
  }

}

export default new IncomeStatementService();



/** WEBPACK FOOTER **
 ** ./src/frilans-finans/income-statements/income-statement-service.js
 **/